// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ae949872","703":"59b5c054","787":"eabec3cc"}[chunkId] + ".chunk.js";
};